import { module } from 'modujs'
import { EAGER_FONTS } from '../app'
import { whenReady } from '../utils/fonts'

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el        = this.el
        this.$inner     = this.$('inner')[0]
        this.$list      = this.$('list')[0]
        this.$innerArea = this.$('innerArea')[0]
        this.$items     = Array.from(this.$('item'))
        this.$links     = Array.from(this.$('link'))

        // Binding
        this.onResizeEndBind = this.onResizeEnd.bind(this)
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        whenReady(EAGER_FONTS).then((fonts) => this.onFontsLoaded(fonts))
        window.addEventListener('resizeEnd', this.onResizeEndBind)
    }

    unbindEvents() {
        window.removeEventListener('resizeEnd', this.onResizeEndBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onFontsLoaded(fonts) {
        this.computeMetrics()
        
        requestAnimationFrame(() => {
            this.call('onResize', null, 'Scroll')
        })
    }

    onResizeEnd() {
        this.computeMetrics()
    }

    onSectionBoundary(args) {
        const way = args.way

        if (way == 'enter') {
            const id = args.target.id
            
            let $currentlink = this.$links.find($link => {
                return $link.getAttribute('href') == '#' + id
            })

            this.$links.forEach($link => {
                $link.classList.remove('is-active')
            })
            $currentlink.classList.add('is-active')
        }
    }

    onListBoundary(args) {
        const way = args.way

        if (way == 'enter') {
            this.$el.classList.add('is-active')
        } else {
            this.$el.classList.remove('is-active')
        }
    }

    onSidebarInview(progress) {
        this.$el.style.setProperty('--inview-progress', progress)
    }

    onSectionProgress(args) {
        const { progress, id } = args

        const $targetItem = this.$items.find(($item) => {
            return $item.dataset.slug == id
        })

        $targetItem.style.setProperty('--section-progress', progress)
    }

    ///////////////
    // Methods
    ///////////////
    computeMetrics() {
        // Get list height
        this.listHeight = this.$list.clientHeight
        
        // Get delta between start / end
        this.delta = this.$innerArea.clientHeight - this.listHeight
        this.$el.style.setProperty('--delta', this.delta)

        // Set sidebar inview area
        this.$el.style.setProperty('--list-height', `${this.listHeight}px`)
    }
}
